import { render, staticRenderFns } from "./FormBuilderOptionItem.vue?vue&type=template&id=3f29ab2d&scoped=true&"
import script from "./FormBuilderOptionItem.vue?vue&type=script&lang=js&"
export * from "./FormBuilderOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderOptionItem.vue?vue&type=style&index=0&id=3f29ab2d&lang=scss&scoped=true&"
import style1 from "./FormBuilderOptionItem.vue?vue&type=style&index=1&id=3f29ab2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f29ab2d",
  null
  
)

export default component.exports